import moment from 'moment';

export var formatDateMixin = {
    filters: {
        formatDate: function formatDate(val) {
            return moment(val, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD/MM/YY');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/format-date.js
// module id = ./src/mixins/format-date.js
// module chunks = 34